import React, {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import View from '../Products/View/View3'
import Footer from '../Footer/Footer'
import './StoreReceipt.css'
import Menu from '../Menu/Menu'

const StoreReceipt = props => {

    //const [paymentId, setPaymentId] = useState(useParams());
    const [order, setOrder] = useState({})
    const [viewLink, setViewLink] = useState({})

    useEffect(() => {
        console.log('param')
        console.log(props.match.params.PaymentId)

        axios({
            //url: 'http://localhost:44316/orders/getorderbypaymentid?PaymentId=' + props.match.params.PaymentId,//g5xUN1prSzs7N8VnxCsreHHGuaB',
            url: 'https://api.caigoycreations.com/orders/getorderbyGUID?GUID=' + props.match.params.GUID,
            method: 'get',
        }).then(
            res => {
                console.log(res.data.data)
                setOrder(res.data.data)
                let tempOrder = res.data.data;
                setViewLink('https://www.caigoycreations.com/products/view/'+tempOrder.Project.GUID)
            },
            err => {
                console.log(err)
                alert(err)
            }
        );

    }, [])

    return (
        <div className='App'>
            <Menu />
            <div className='StoreReceipt'>
                <br /><br /><br />
                <br />
                {order.GUID && 
                    <div>
                        <View GUID={order.Project.GUID} />
                        <div className='StoreReceiptDetails'>
                            <div className='ReceiptLogo'>
                                <img 
                                    // src='https://www.caigoycreations.com/static/media/Logo-Tall.jpg'
                                    src='https://caigoycreations.com/static/media/Logo-Long.png'
                                />
                                <h2 style={{margin: '0 auto'}}>Store <span>Receipt</span></h2>
                            </div>

                            <div className='ReceiptItem'>
                                <br />
                            </div>

                            <div className='ReceiptItem'>
                                <label>Date Purchased</label> 
                                <label>{order.DateOrderedString}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>Payment:</label>
                                <label>{order.PaymentInfo}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>Item:</label>  
                                <label>{order.Project.Product.Name}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>Quantity:</label>  
                                <label>{order.Quantity}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>SubTotal:</label>  <label>{order.SubTotal.toFixed(2)}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>Tax:</label>  
                                <label>{order.Tax.toFixed(2)}</label>
                            </div>

                            <div className='ReceiptItem'>
                                <label>Shipping Price</label> 
                                <label>{order.ShippingPrice.toFixed(2)}</label>
                            </div>
                            <hr />

                            <div className='ReceiptItem'>
                                <strong>Total</strong> 
                                <strong>${order.Total.toFixed(2)}</strong>
                            </div>

                            <br />

                            {order.AdditionalComments &&
                                <div>
                                    <label>Additional Comments:</label>
                                    <br />
                                    {order.AdditionalComments}
                                    <br />
                                </div>
                            }

                            <div className='Questions' >
                                For any questions, issues, or concerns about your order, 
                                please send an email to {' '}
                                <a href="mailto://caigoycreations@gmail.com">caigoycreations@gmail.com</a>
                                
                                <br /><br />
                                
                            </div>

                            <div className='OrderMore'>
                                <a href={viewLink} >Order More!</a>
                            </div>

                        </div>
                    </div>
                }
                <div className='Spacer'></div>
                <Footer />
            </div>
        </div>
    )

}

export default StoreReceipt;